import { defineAction } from '~/prix'
import { dateOrIsoString } from '~/prix/types/date'
import { z } from 'zod'
import { reportFormatSchema } from '~/utils/server/report'
import veterinaryCareReportAction from './veterinaryCareReport.action.json' with { type: 'json' }

const veterinaryCareReportInputSchema = z.preprocess(rawInput => {
  if (typeof rawInput !== 'object' || rawInput === null || Array.isArray(rawInput)) {
    return rawInput
  }

  const input = rawInput as Record<string, unknown>

  return {
    ...input,
    startDate: input.startDate ?? input.serviceDate ?? null,
    endDate: input.endDate ?? input.closedAt ?? null,
  }
}, z.object({
  format: reportFormatSchema,
  citizenId: z.string().nullish(),
  startDate: dateOrIsoString().nullish(),
  endDate: dateOrIsoString().nullish(),
  careType: z.string().nullish(),
}))

const veterinaryCareReportDefinition = defineAction({
  ...veterinaryCareReportAction,

  input: veterinaryCareReportInputSchema,
  output: z.any(),
})

export default veterinaryCareReportDefinition
